// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__3B9Jk","file":"styles_file__1oYfw"};